import { create } from "zustand";
import { GenderTypeKey } from "../../user/partner/Gender";
import { WorkplaceKey } from "../../user/partner/Workplace";
import { AvailabilityKey } from "../../user/partner/Availability";
import { MassageCategoryKey } from "../../user/partner/MassageCategoryKey";
import { ClientTypeKey } from "../../user/client/ClientType";
import { PaymentMethodKey } from "../../user/partner/PaymentMethod";
import { CurrencyKey } from "../../price/CurrencyUtil";

interface SearchPartnerProfileStore {
  priceFrom?: number;
  setPriceFrom: (priceFrom: number) => void;

  priceTo?: number;
  setPriceTo: (priceTo: number) => void;

  currency?: CurrencyKey;
  setCurrency: (currency: CurrencyKey) => void;

  paymentMethods?: PaymentMethodKey[];
  setPaymentMethods: (paymentMethods: PaymentMethodKey[]) => void;

  isVisitingClient?: boolean;
  setIsVisitingClient: (isVisitingClient: boolean) => void;

  genders?: GenderTypeKey[];
  setGenders: (genders: GenderTypeKey[]) => void;

  clientTypes?: ClientTypeKey[];
  setClientTypes: (clientTypes: ClientTypeKey[]) => void;

  workplaces?: WorkplaceKey[];
  setWorkplaces: (workplaces: WorkplaceKey[]) => void;

  availabilities?: AvailabilityKey[];
  setAvailabilities: (availabilities: AvailabilityKey[]) => void;

  name?: string;
  setName: (name: string) => void;

  serviceCategory?: MassageCategoryKey;
  setServiceCategory: (serviceCategory: MassageCategoryKey) => void;

  city?: string;
  setCity: (city: string) => void;

  page?: number;
  setPage: (page: number) => void;

  pageSize?: number;
  setPageSize: (pageSize: number) => void;
}

export const useSearchPartnerStore = create<SearchPartnerProfileStore>(
  (set) => ({
    priceFrom: undefined,
    setPriceFrom: (priceFrom) => set({ priceFrom }),

    priceTo: undefined,
    setPriceTo: (priceTo) => set({ priceTo }),

    currency: undefined,
    setCurrency: (currency) => set({ currency }),

    paymentMethods: undefined,
    setPaymentMethods: (paymentMethods) => set({ paymentMethods }),

    isVisitingClient: undefined,
    setIsVisitingClient: (isVisitingClient) => set({ isVisitingClient }),

    genders: undefined,
    setGenders: (genders) => set({ genders }),

    clientTypes: undefined,
    setClientTypes: (clientTypes) => set({ clientTypes }),

    workplaces: undefined,
    setWorkplaces: (workplaces) => set({ workplaces }),

    availabilities: undefined,
    setAvailabilities: (availabilities) => set({ availabilities }),

    name: undefined,
    setName: (name) => set({ name }),

    serviceCategory: undefined,
    setServiceCategory: (serviceCategory) => set({ serviceCategory }),

    city: undefined,
    setCity: (city) => set({ city }),

    page: 1,
    setPage: (page) => set({ page }),

    pageSize: undefined,
    setPageSize: (pageSize) => set({ pageSize }),
  })
);
